import missionWizardImage from '../../../../ui/assets/missionWizardImage.svg';
import { useMissionsTranslation } from '../../../../ui/hooks';
import { FullScreenWizard } from '@juvare/common-form-ui/FullScreenWizard';
import { showConfirmDialog } from '@juvare/common-web-ui/DialogHelper';
import { NavigationContext } from '@juvare/common-web-ui/NavigationContext';
import { Typography } from '@mui/material';
import React from 'react';
import { useNavigate, useParams } from 'react-router';
import { useCreateShift } from '../hooks/useCreateShift';
export const NewShift = () => {
    const { t } = useMissionsTranslation();
    const [changed, setChanged] = React.useState(false);
    const { missionId } = useParams();
    const navigate = useNavigate();
    const navigationContext = React.useContext(NavigationContext);
    const handleNavigateBack = () => navigationContext.navigate(() => navigate(-1));
    const handleCancel = () => {
        if (changed) {
            showConfirmDialog({
                title: t('wizard.confirmWizardCloseTitle'),
                confirmLabel: t('wizard.closeWizardConfirmLabel'),
                cancelLabel: t('wizard.closeWizardCancelLabel'),
                content: React.createElement(Typography, { variant: 'body1' }, wizardConfig.closeWizardContent),
                onConfirm: () => {
                    navigationContext.clearChanged();
                    handleNavigateBack();
                },
            });
        }
        else {
            navigationContext.navigate(() => handleNavigateBack());
        }
    };
    const handleChanged = React.useCallback((changed) => {
        if (changed) {
            navigationContext.setChanged(t('wizard.confirmWizardCloseTitle'));
        }
        else {
            navigationContext.clearChanged();
        }
        setChanged(changed);
    }, [t, navigationContext]);
    const handleSubmitSuccess = () => {
        navigationContext.clearChanged();
        handleNavigateBack();
    };
    const { wizardConfig } = useCreateShift({
        missionId,
    });
    return (React.createElement(FullScreenWizard, { open: true, image: { src: missionWizardImage, alt: 'New Shift' }, title: wizardConfig.title, steps: wizardConfig.steps, onCancel: handleCancel, onChanged: handleChanged, onSubmit: wizardConfig.onSubmit, onSubmitSuccess: handleSubmitSuccess }));
};
